import request from '@/utils/request';
//获取新闻列表
export function getNewsList(params) {
  return request({
    url: '/api/lk/queryLkNewsList',
    method: 'post',
    data: JSON.stringify(params),
  });
}
//查询感兴趣业务列表
export function getBusinessesList() {
  return request({
    url: '/api/lk/queryBusinessesList',
    method: 'get',
  });
}
//提交表单
export function submitContactUsInfo(params) {
  return request({
    url: '/api/lk/contactUs',
    method: 'post',
    data: JSON.stringify(params),
  });
}
